import { Route }     from 'react-router-dom';
import ShowHome      from './views/ShowHome';
import ShowList      from './views/ShowList';
import ShowDashboard from './views/ShowDashboard';

export default [
  <Route element={<ShowHome />} key="home" path="/" />,
  <Route element={<ShowList />} key="list" path="/salons" />,
  <Route element={<ShowDashboard />} key="show" path="/salons/:showId" />,
];
